import React from "react";
import "./CustomCard.css";
import { Link } from "react-router-dom";

const CustomCard = ({
  title,
  count,
  icon,
  link,
  bgColor = "bg-blue", // Default red background
  txtColor = "text-dark", // Default text color
  iconBorderColor = "border-dark", // Default border color
  boxShadow = "shadow-lg", // Box shadow
  isFirst = "",
  bgBorder = "border-dash",
}) => {
  return (
    <div className="col-lg-4 col-md-12 mb-4">
      <div
        className={`d-flex justify-content-between align-items-center px-3 py-4 rounded-4
        ${isFirst ? bgColor : ""}
        ${!isFirst ? bgBorder : ""}
        ${txtColor}
        ${boxShadow}
        `}
        style={{ backgroundColor: "var(--color-dark)" }}
      >
        <div className="textview">
          <div className="textview-text">{title}</div>
          <div className="textview-num mt-1">{count}</div>
        </div>

        <div className="linkview flex items-center gap-2">
          <div
            className={`iconclr border p-2 rounded-2 text-center mb-3 ${iconBorderColor}
            ${isFirst ? "text-white border-white" : ""}`}
          >
            {icon}
          </div>
          <div className="link-sty">
            {link && (
              <Link to={link} className={isFirst ? "text-white" : ""}>
                View All
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomCard;
